import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { StatusLabelComponent } from '@principle-theorem/ng-principle-shared';
import {
  PARTNER_TEST_ACCOUNT_STATUS_MAP,
  PartnerTestAccountStatus,
} from '@principle-theorem/principle-core/interfaces';

@Component({
  selector: 'pr-test-account-status',
  templateUrl: './test-account-status.component.html',
  styleUrls: ['./test-account-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [StatusLabelComponent],
})
export class TestAccountStatusComponent {
  @Input() status: PartnerTestAccountStatus;
  isDense = false;
  statusColourMap: {
    [key in PartnerTestAccountStatus]: string;
  } = PARTNER_TEST_ACCOUNT_STATUS_MAP;

  @Input()
  set dense(dense: BooleanInput) {
    this.isDense = coerceBooleanProperty(dense);
  }
}
